/* istanbul ignore file */
import { connect } from '@lumapps/redux/react';
import { BackOfficeStore } from '@lumapps/redux/types';

import { canAccessMediaLibrary } from '../../ducks/selectors';
import { MediaSideNavigation } from './MediaSideNavigation';

const mapStateToProps = (state: BackOfficeStore) => {
    const isAllowed = canAccessMediaLibrary(state);

    return {
        isAllowed,
    };
};

const mapDispatchToProps = {};

const ConnectedMediaSideNavigation = connect(mapStateToProps, mapDispatchToProps)(MediaSideNavigation);

export { ConnectedMediaSideNavigation as MediaSideNavigation };
